import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaClock,
  FaArrowRight,
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaTwitter,
} from "react-icons/fa";
import "./contact.css";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    service: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    console.log("Form Data:", formData);

    alert("Thank you! Your message has been submitted.");

    setFormData({
      name: "",
      email: "",
      phone: "",
      service: "",
      message: "",
    });
  };

  const contactInfo = [
    {
      icon: <FaPhoneAlt />,
      title: "Call Us",
      text: "+91 85881 22522",
      link: "tel:+919876543210",
    },
    {
      icon: <FaEnvelope />,
      title: "Email Us",
      text: "info@liquidtextnotability.com",
      link: "mailto:info@liquidtextnotability.com",
    },
    {
      icon: <FaMapMarkerAlt />,
      title: "Visit Us",
      text: "Ahmedabad, Gujarat, India",
      link: "#",
    },
    {
      icon: <FaClock />,
      title: "Working Hours",
      text: "Mon - Sat: 9:00 AM - 6:00 PM",
      link: "#",
    },
  ];
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant", // or "smooth"
    });
  }, [pathname]);

  return (
    <section className="contact-page">
      {/* Background Shapes */}
      <div className="contact-bg-shape shape-one"></div>
      <div className="contact-bg-shape shape-two"></div>

      <div className="container">
        {/* Header */}
        <motion.div
          className="contact-heading text-center"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          <span className="contact-subtitle">GET IN TOUCH</span>

          <h1>
            Let's Start a <span>Conversation</span>
          </h1>

          <p>
            Have a project in mind or need help with your next digital solution?
            We'd love to hear from you. Let's create something amazing together.
          </p>
        </motion.div>

        <div className="row g-5 align-items-stretch contact-main">
          {/* LEFT SIDE */}
          <div className="col-lg-5">
            <motion.div
              className="contact-left"
              initial={{ opacity: 0, x: -60 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
            >
              <div className="contact-left-content">
                <span className="small-title">CONTACT INFORMATION</span>

                <h2>
                  We're here to
                  <br />
                  <span>help you.</span>
                </h2>

                <p className="contact-description">
                  Whether you have a question, need a quote, or want to discuss
                  a project, our team is ready to help you.
                </p>

                <div className="contact-info-list">
                  {contactInfo.map((item, index) => (
                    <motion.a
                      href={item.link}
                      className="contact-info-item"
                      key={index}
                      initial={{ opacity: 0, y: 20 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      viewport={{ once: true }}
                      transition={{
                        duration: 0.5,
                        delay: index * 0.1,
                      }}
                    >
                      <div className="contact-icon">{item.icon}</div>

                      <div>
                        <small>{item.title}</small>
                        <p>{item.text}</p>
                      </div>
                    </motion.a>
                  ))}
                </div>

                {/* Social Media */}
                <div className="contact-social">
                  <span>FOLLOW US</span>

                  <div className="social-icons">
                    <a href="#">
                      <FaFacebookF />
                    </a>

                    <a href="#">
                      <FaInstagram />
                    </a>

                    <a href="#">
                      <FaLinkedinIn />
                    </a>

                    <a href="#">
                      <FaTwitter />
                    </a>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>

          {/* RIGHT SIDE FORM */}
          <div className="col-lg-7">
            <motion.div
              className="contact-form-card"
              initial={{ opacity: 0, x: 60 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
            >
              <div className="form-heading">
                <span>LET'S TALK</span>

                <h3>Tell us about your project</h3>

                <p>
                  Fill out the form below and our team will get back to you
                  shortly.
                </p>
              </div>

              <form onSubmit={handleSubmit}>
                <div className="row">
                  {/* Name */}
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Full Name</label>

                      <input
                        type="text"
                        name="name"
                        placeholder="Enter your name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                      />
                      <span className="input-line"></span>
                    </div>
                  </div>

                  {/* Email */}
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Email Address</label>

                      <input
                        type="email"
                        name="email"
                        placeholder="Enter your email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                      <span className="input-line"></span>
                    </div>
                  </div>

                  {/* Phone */}
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Mobile Number</label>

                      <input
                        type="tel"
                        name="phone"
                        placeholder="+91 00000 00000"
                        value={formData.phone}
                        onChange={handleChange}
                        required
                      />
                      <span className="input-line"></span>
                    </div>
                  </div>

                  {/* Service */}
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Select Service</label>

                      <select
                        name="service"
                        value={formData.service}
                        onChange={handleChange}
                        required
                      >
                        <option value="">Choose a service</option>
                        <option value="web-development">Web Development</option>
                        <option value="app-development">App Development</option>
                        <option value="ui-ux">UI/UX Design</option>
                        <option value="digital-marketing">
                          Digital Marketing
                        </option>
                        <option value="software-development">
                          Software Development
                        </option>
                      </select>

                      <span className="input-line"></span>
                    </div>
                  </div>

                  {/* Message */}
                  <div className="col-12">
                    <div className="form-group">
                      <label>Your Message</label>

                      <textarea
                        name="message"
                        rows="4"
                        placeholder="Tell us about your project..."
                        value={formData.message}
                        onChange={handleChange}
                        required
                      ></textarea>

                      <span className="input-line"></span>
                    </div>
                  </div>

                  {/* Button */}
                  <div className="col-12">
                    <button type="submit" className="contact-submit">
                      Send Message
                      <span>
                        <FaArrowRight />
                      </span>
                    </button>
                  </div>
                </div>
              </form>
            </motion.div>
          </div>
        </div>

        {/* MAP SECTION */}
        <motion.div
          className="contact-map"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <iframe
            title="Google Map"
            src="https://www.google.com/maps?q=Ahmedabad,Gujarat,India&output=embed"
            loading="lazy"
            allowFullScreen
          ></iframe>
        </motion.div>
      </div>
    </section>
  );
};

export default Contact;
